module.exports = __webpack_public_path__ + "static/media/handshake.ff139888.svg";